"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCache = void 0;
var swr_1 = require("swr");
var react_1 = require("react");
var useCache = function () {
    var cache = (0, swr_1.useSWRConfig)().cache;
    var getDataFromCache = (0, react_1.useCallback)(function (key) { var _a; return (_a = cache.get(key)) === null || _a === void 0 ? void 0 : _a.data; }, [cache]);
    var setDataToCache = (0, react_1.useCallback)(function (key, data) { return cache.set(key, { data: data }); }, [cache]);
    return (0, react_1.useMemo)(function () { return ({
        getDataFromCache: getDataFromCache,
        setDataToCache: setDataToCache,
    }); }, [getDataFromCache, setDataToCache]);
};
exports.useCache = useCache;
